const equation_store = {
    subscribers:{},
    equations: [],
    loading: true,
    isLoading(){
        return this.loading
    },
    setLoading(boolean){
        this.loading = boolean
    },
    setEquations(equations){
        this.equations = equations
        this.publish('SET_EQUATIONS', equations)
    },
    equationsFromStation(station_id){
        return this.equations.filter(x=>x.equationable.id === station_id)
    },
    getDams(){
        return this.dams
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default equation_store